import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiPasswordIndicatorModule } from '@components/ui-password-indicator/ui-password-indicator.module';
import { UiPasswordTypeToggleModule } from '@components/ui-password-toggle/ui-password-toggle.module';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { UiValueTypeComponent } from '@components/ui-value-type/ui-value-type.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        UiToggleSwitchModule,
        UiPasswordTypeToggleModule,
        UiPasswordIndicatorModule,
        MatInputModule,
    ],
    declarations: [
        UiValueTypeComponent,
    ],
    exports: [
        UiValueTypeComponent,
    ],
})
export class UiValueTypeModule { }
